// Entry point for the build script in your package.json

// @ts-expect-error: @hotwired/turbo is not typed
import * as Turbo from '@hotwired/turbo'

import initReact from 'components'
import { initBraze } from 'lib/braze'
import { initIntercom } from 'lib/intercom'
import { initPostHog } from 'lib/posthog'
import { initSegment } from 'lib/segment'
import { initSentry } from 'lib/sentry'

// Bootstrap Stimulus application and load all Stimulus controllers.
import 'controllers' // eslint-disable-line import-x/no-unassigned-import

// Keep this at the top to ensure Sentry is initialized as early as possible.
initSentry()

// Disable Turbo Drive globally. It can be enabled where needed with `data-turbo="true"`.
Turbo.session.drive = false

// Initialize React. This loads all our React components and sets up the event handlers responsible for
// mounting the components.
initReact()

initPostHog()
initSegment()
initBraze()
initIntercom()

// Empty export to silence a warning from Sentry's esbuild plugin.
// Cf. https://github.com/getsentry/sentry-javascript-bundler-plugins/issues/747
export default {}
